import { SPINNER } from "../assets/animated";

export default function LoadingContent() {
  return (
    <div className="w-full h-full min-h-[300px] flex items-center justify-center">
      <img src={SPINNER} className="w-10" />
    </div>
  )
}